// extracted by mini-css-extract-plugin
export default {"wrapper":"ADSButton_wrapper__N-WEl","disabled":"ADSButton_disabled__iqUK6","icon":"ADSButton_icon__rtQUz"};